import { Component } from '@angular/core';
import { KeycloakService } from "keycloak-angular";
import { environment } from "../../environments/environment";

@Component({
  selector: 'app-error-sin-permiso',
  standalone: true,
  imports: [],
  templateUrl: './error-sin-permiso.component.html',
  styleUrl: './error-sin-permiso.component.scss'
})
export class ErrorSinPermisoComponent {

  constructor(private keycloakService: KeycloakService) {
  }

  cerrarSesion() {
    this.keycloakService.logout(environment.keyCloakRedirectUri);
  }

}
